import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { buffaloConfig } from "./data";

export default function BuffaloPage() {
  return <CityPageTemplate config={buffaloConfig} />;
}